import { useNavigate } from 'react-router-dom';
import {SettingsContext} from '../components/userSettingsContext';
import { useState, useEffect, forwardRef, useRef, useImperativeHandle } from "react"

import {CcStepper2, StepperNavButtons} from "../commonComponents/stepper"

import axios from 'axios';

import {IconButton, Radio, Tooltip} from '@mui/material';

import {CcProgressBar, InfoToolTip, LionLoaderGradient} from '../commonComponents/generalComponents'
import {SnippetCodeViewer} from '../commonComponents/snippetGeneric'
import {CcCheckbox, InputText, InputNumber, InputURL, FileSelector, LionCombo} from '../commonComponents/inputFields'
import {ccColorDarkTeal, lionObjectsColors}  from "../components/helpersStyles";

import { Icon as Iconify } from '@iconify/react';

import { getErrorListFromYupError, getErrorMessage, getErrorMessageForArray, snippetDataValidationSchemaTimedImages } from '../components/helperErrors'
import { CcActionButton, CcActionButtonOutlined } from '../commonComponents/styledTexts';
import { string } from 'yup';
import { GetSnippetIdfromSnippetHtml } from '../components/helpers';

import { RandomId } from '../components/helpers';

import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { renderTimeViewClock } from '@mui/x-date-pickers/timeViewRenderers';
import dayjs from 'dayjs';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';

import { lionIcons } from '../components/helpersIcons';


const Connector_HorizontalFlow = (props) => {
  useEffect(() => {console.log(props.img)}, [props.img])

  return <div className='relative flex flex-row gap-x-0 items-center text-ccColorTeal'>
    <hr class="w-[300px] border-[6px] border-ccColorTeal" />
  <Iconify icon="bxs:up-arrow" rotate={45} width={32} className='-ml-[8px]' />
  <div className="absolute h-[50px] w-[4px] bg-slate-300 left-[148px] bottom-[22px]"></div>
  <div className="absolute w-4 h-4 bg-slate-300 rounded-full left-[142px] bottom-[60px]"></div>
  <div className='absolute w-[300px] h-[300px] border border-slate-300 rounded-md bottom-[58px]'>
    <div className='h-[210px]'>
      {(props.img && props.img.length > 0) ? <div></div>
      :
      <div className='mt-2 flex flex-col items-center'>
          <FileSelector noDeleteButton
            text="Upload image"
            //onChange={handleImageChange}
          />      
      </div>
      }
    </div>
    <div className="w-[280px] ml-2">
        <InputText
                displayName="Href"
                //value={snippetName}
                //onChange={(val) => {handleSnippetNameChange(val);}}
                //error={getErrorMessage(props.validationErrorsList, 'snippetName')}
        />
    </div>

  </div>

</div>
}

const TimelineEditor_HorizontalFlow = (props) => {
  const initialTimeline = {dates: [{date: dayjs().toJSON(),
                                                 assetIdBefore: 'first', assetIdAfter: '', 
                                                 }
                                  ],
                          assets: [{id: 'first',  href: '', img: '', tagId: '' }]  
                          }
  //IMPORTANT: each date only needs to have a BEFORE asset. 
  // the AFTER asset is used only by the last date of the timeline!

  const [timeline, setTimeline] = useState(initialTimeline)

  const getNewEmptyAsset = () => {
    const result = {id: RandomId(10),
                      href: '', img: '',
                      tagId: ''
                    }
    return result;
  }

  const handleAddDate = (index) => {
    if (index) {

    }
    else {
      //when no index passed, we add in the last position
      //previousLastDate.after becomes the newLastDate.before
      //previousLastDate.after can get cleaned

      const previousLastDate = timeline.dates.at(-1);
      const newDatetime = dayjs(previousLastDate.date).add(1, 'day')
      const newDate = {date: newDatetime.toJSON(), assetIdBefore: previousLastDate.assetIdAfter, }
      previousLastDate.assetIdAfter = '';

      const newDates = [...timeline.dates.slice(0, -2), previousLastDate, newDate]
      const newTimeline = {...timeline, dates: newDates}
      setTimeline(newTimeline)
    }
  }
  const getImageDataFromId = (id) => {
    for (const img of timeline.images) {
      if (img.id === id) return img.data
    }
    return ''
  }

  return <div className=''>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
    <div className='mt-[340px] mb-2 flex flex-row'>
      {timeline.dates.map((d, index) => {
        return <div className='flex flex-row items-center gap-x-0'>
          <Connector_HorizontalFlow  />
      <DateTimePicker sx={{width: 196}}
            value={dayjs(d.date)}
            ampm={false}
            viewRenderers={{
              hours: renderTimeViewClock,
              minutes: renderTimeViewClock,
              seconds: renderTimeViewClock,
            }}
            //onChange={handleTimerDateChange}
          />
          {index === timeline.dates.length -1 &&
            <Connector_HorizontalFlow />        
          }
        </div>
    })}
    <IconButton onClick={() => handleAddDate()}>
      <Iconify icon={lionIcons.Icon_Actions_Add} width={42} className='text-ccColorDarkTeal' />
    </IconButton>
    </div>
    </LocalizationProvider>
  </div>
}

const Connector = (props) => {
  //useEffect(() => {console.log(props.asset)}, [props.asset])

  const handleAssetChange = (propName, propValue) => {
    const updatedAsset = {...props.asset, [propName]: propValue}
    if (props.onChange) props.onChange(updatedAsset)
  }
  const renderStats = () => {
    if (props.asset == null || props.stats == null) return;
    let matched = props.stats.find(s => s.id === props.asset.id)
    if (matched == null) {
      matched = {totalOpens: 0, totalClicks: 0}
    }

    return <div className='flex flex-col text-ccColorDarkTeal'>
      <div className='font-semibold'>Opens</div>
      <div className='text-4xl font-semibold'>{matched.totalOpens}</div>
      <div className='h-8'></div>
      <div className='font-semibold'>Clicks</div>
      <div className='text-4xl font-semibold'>{matched.totalClicks}</div>

    </div>
  }
  const handleDeleteAsset = () => {
    if (props.onDelete) props.onDelete(props.asset.id, props.date1, props.date2)
  }

  return <div className='relative flex flex-col gap-y-0 items-center text-ccColorTeal mt-2'>    
    <div className="h-[300px] w-[4px] bg-ccColorTeal"></div>
    <Iconify icon="bxs:up-arrow" rotate={90} width={32} className='-mt-[8px]' />
    <hr class="absolute w-[120px] border-[3px] bg-slate-300 top-[148px] left-[18px]"  />
    <div class="absolute w-[248px] h-48 border-slate-900 top-[54px] -left-[258px] flex items-center justify-center text-sm font-semibold"  >
      {props.date1 === undefined && props.date2 && <div className='text-center'>This image will be shown before {dayjs(props.date2).format('DD/MM/YYYY HH:mm')}</div>}
      {props.date1 && props.date2 && <div className='text-center'>This image will be shown between {dayjs(props.date1).format('DD/MM/YYYY HH:mm')} and {dayjs(props.date2).format('DD/MM/YYYY HH:mm')}</div>}
      {props.date1 && props.date2 === undefined && <div className='text-center'>This image will be shown after {dayjs(props.date1).format('DD/MM/YYYY HH:mm')}</div>}
    </div>

    <div className="absolute w-4 h-4 bg-slate-300 rounded-full top-[143px] left-[130px]"></div>
    <div className='absolute w-[800px] h-[280px] border border-slate-300 rounded-md left-[128px] p-1'>
      <div className='h-[250px] ml-4 mt-2 flex flex-row gap-x-24 items-center'>
        {(props.asset && props.asset.img.length > 0) ? <div className='relative bg-slate-200 rounded p-4 w-[260px] h-[250px] flex justify-center'>
              <div className=' h-full' >
                  <img style={{height: 'auto', width: 'auto', maxWidth: '100%', maxHeight: '100%'}} src={`${props.asset.img}`} />
                  {(props.reportMode == null) &&
                  <div className='absolute top-0 right-0 text-black hover:cursor-pointer hover:bg-slate-300 p-[2px] rounded-full'
                        onClick={() => handleAssetChange('img', '')}><Iconify icon={lionIcons.Icon_Actions_Cancel} width={24} />
                  </div>
                }
              </div>
            </div>

        :
        <div className='relative bg-slate-200 rounded p-4 w-[260px] h-[250px] flex flex-col justify-center items-center'>
            {props.errorImg && props.errorImg.length > 0 && <div className=' text-red-500 text-sm font-semibold font-poppins'>{props.errorImg}</div>}

            <FileSelector noDeleteButton
              text="Upload image"
              onChange={(dataUrl) => handleAssetChange('img', dataUrl)}
            />      
        </div>
        }
        {(props.reportMode == null) &&
        <div className="w-[360px]">
            <InputText
                    displayName="Href"
                    value={props.asset.href}
                    onChange={(val) => {handleAssetChange('href', val);}}
                    error={props.errorHref}
            />
        </div>
        }
        {props.reportMode && props.stats && <>
          {renderStats()}
        </>

        }
      </div>
      {props.canDelete &&
      <div className='absolute top-[130px] -right-12'>
        <IconButton onClick={handleDeleteAsset}><Iconify icon={lionIcons.Icon_Actions_Delete} /></IconButton>
      </div>
      }
  </div>
</div>
}


export const TimelineEditor = (props) => {
  const initialTimeline = {dates: [{date: dayjs().add(1, 'day').startOf('day').toJSON(),
                                                 assetIdBefore: 'first', assetIdAfter: 'second', 
                                                 }
                                  ],
                          assets: [{id: 'first',  href: '', img: '', tagId: '' },
                                  {id: 'second',  href: '', img: '', tagId: '' }
                          ]  
                          }
  //IMPORTANT: each date only needs to have a BEFORE asset. 
  // the AFTER asset is used only by the last date of the timeline!

  const [timeline, setTimeline] = useState(initialTimeline)
  const [mppImage, setMppImage] = useState('')

  //UI only, it used with the DatePicker
  const [dateRanges, setDateRanges] = useState([{minDate: undefined, maxDate: undefined}])

  useEffect(() => {
    if (props.timeline) {
      setTimeline(props.timeline)
      setMppImage(props.timeline.imageMPP)
      calculateDateRanges(props.timeline.dates)
    }

  }, [props.timeline], [props.mppImage])

  const calculateDateRanges = (dates) => {
    if (timeline == null) return [{minDate: undefined, maxDate: undefined}]

    const newDateRanges = []
    dates.forEach((d,index) => {
      const newD = {}
      if (index === 0) newD.minDate = undefined
      else newD.minDate = dayjs(dates[index -1].date)

      if (index < dates.length -1) newD.maxDate = dayjs(dates[index +1].date)
      else newD.maxDate = undefined

      newDateRanges.push(newD)
    })
    //console.log(newDateRanges)
    setDateRanges(newDateRanges)
  }

  const getNewEmptyAsset = () => {
    const result = {id: RandomId(10),
                      href: '', img: '',
                      tagId: ''
                    }
    return result;
  }

  const handleAddDate = (index) => {
    if (index) {

    }
    else {
      //when no index passed, we add in the last position
      //previousLastDate.after becomes the newLastDate.before
      //previousLastDate.after can get cleaned
      //newLastDate.after gets assigned a new empty asset

      const previousLastDate = timeline.dates.at(-1);
      const newDatetime = dayjs(previousLastDate.date).add(1, 'day')
      const newAsset = getNewEmptyAsset()
      const newDate = {date: newDatetime.toJSON(), assetIdBefore: previousLastDate.assetIdAfter, assetIdAfter: newAsset.id }
      previousLastDate.assetIdAfter = '';

      const newDates = [...timeline.dates.slice(0, -1), previousLastDate, newDate]
      const newAssets = [...timeline.assets, newAsset]
      const newTimeline = {...timeline, assets: newAssets, dates: newDates}

      calculateDateRanges(newDates)
      setTimeline(newTimeline)
      if (props.onChange) props.onChange(newTimeline)
    }
  }

  const getAssetFromId = (id) => {
    for (const asset of timeline.assets) {
      if (asset.id === id) return asset
    }
  }

  const handleAssetChange = (asset) => {
    const index = timeline.assets.findIndex(a => a.id === asset.id)
    const newAssets = [...timeline.assets]
    newAssets.splice(index, 1, asset);
    const newTimeline = {...timeline, assets: newAssets}
    setTimeline(newTimeline)
    
    if (props.onChange) props.onChange(newTimeline)
  }
const handleDateChange = (index, newDate) => {
  const newDateObj = timeline.dates[index];
  //newDateObj.date = newDate.toJSON()
  newDateObj.date = newDate.format('YYYY-MM-DDTHH:mm:ss.000')

  const newDates = [...timeline.dates]
  newDates.splice(index, 1, newDateObj)

  const newTimeline = {...timeline, dates: newDates}
  setTimeline(newTimeline)
  calculateDateRanges(newDates)
  //console.log(newDates)

}
const handleAssetDelete = (assetId, date1, date2) => {
  const index = timeline.assets.findIndex(a => a.id === assetId)
  const newAssets = [...timeline.assets]
  newAssets.splice(index, 1);

  // simplified scenario:
  // we always delete the asset and the date "after"
  // except for the last assets which doesn't have a date after and we have to delete the date "before"

  const newDates = [...timeline.dates]
  if (date2) {
    const dateIndex = newDates.findIndex(d => d.date === date2)

    //if the date to cancel is the last one then we need to take its afterAsset and set it in the date before
    if (dateIndex === newDates.length -1) {
      newDates[index-1].assetIdAfter = newDates[index].assetIdAfter
    }

    newDates.splice(dateIndex,1)
  }
  else {
    //if we are here we are deleting the last date
      const numDates = newDates.length
      newDates[numDates-2].assetIdAfter = newDates[numDates-1].assetIdBefore
      newDates.splice(numDates-1,1)
  }

    //console.log({dates: newDates, assets: newAssets})

    setTimeline({dates: newDates, assets: newAssets})
}
const handleImageMPPChange = (value) => {
  setMppImage(value)
  if (props.onMppChange) props.onMppChange(value)
}

  return <div className='ml-48'>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
    <div className='mt-[40px] mb-2 items-start flex flex-col'>
      {timeline.dates.map((d, index) => {
        return <div className='flex flex-col items-center gap-y-0'>
          <Connector asset={getAssetFromId(d.assetIdBefore)}
              onChange={handleAssetChange}
              onDelete={handleAssetDelete}
              errorImg={getErrorMessageForArray(props.validationErrorsList, 'timelineImages', index)}
              errorHref={getErrorMessageForArray(props.validationErrorsList, 'timelineHref', index)}
              reportMode={props.reportMode}
              stats={props.stats}
              date1={index > 0 ? timeline.dates[index-1].date : undefined}
              date2={d.date}
              canDelete={timeline.dates.length > 1}
          />
      <DateTimePicker sx={{width: 196}}
            value={dayjs(d.date)}
            minDateTime={dateRanges[index].minDate}
            maxDateTime={dateRanges[index].maxDate}
            ampm={false}
            format="DD/MM/YYYY HH:mm"
            viewRenderers={{
              hours: renderTimeViewClock,
              minutes: renderTimeViewClock,
              seconds: renderTimeViewClock,
            }}
            onChange={(val) => handleDateChange(index, val)}
          />
          {index === timeline.dates.length -1 &&
            <Connector asset={getAssetFromId(d.assetIdAfter)}
            onChange={handleAssetChange}
            onDelete={handleAssetDelete}
            errorImg={getErrorMessageForArray(props.validationErrorsList, 'timelineImages', index +1)}
            errorHref={getErrorMessageForArray(props.validationErrorsList, 'timelineHref', index +1)}
            reportMode={props.reportMode}
            stats={props.stats}
            date1={d.date}
            canDelete={timeline.dates.length > 1}
            />        
          }
        </div>
    })}
    {(props.reportMode == null) &&
    <div onClick={() => handleAddDate()} className='flex flex-row items-center text-ccColorDarkTeal border border-2 border-ccColorDarkTeal py-1 px-2 rounded hover:cursor-pointer hover:bg-slate-100' >
      <Iconify icon={lionIcons.Icon_Actions_Add} width={32} />
      <div className='font-poppins'>Add new Timed Image</div>
    </div>
    }
    </div>
    <div className='mt-12 text-black font-semibold'>MPP option</div>
    <div className='flex flex-row items-center gap-x-2'>
      <div className='font-poppins text-sm'>Display this image to anybody opening with Mail Privacy Protection enabled</div>
      <InfoToolTip 
        placement="top-end"
        headLine='MPP Link'
        message="Upon click, this image will direct users to the link for the condition met. We recommend keeping the content for this image generic enough to fit all scenarios."
      />

    </div>

      {mppImage && mppImage.length > 0 ? <div className='relative bg-slate-200 rounded p-4 w-[260px] h-[250px] flex justify-center'>
            <div className=' h-full' >
                <img style={{height: 'auto', width: 'auto', maxWidth: '100%', maxHeight: '100%'}} src={`${mppImage}`} />
                {(props.reportMode == null) &&
                <div className='absolute top-0 right-0 text-black hover:cursor-pointer hover:bg-slate-300 p-[2px] rounded-full'
                      onClick={() => handleImageMPPChange('')}><Iconify icon={lionIcons.Icon_Actions_Cancel} width={24} />
                </div>
              }
            </div>
          </div>
          :
          <FileSelector noDeleteButton
            text="Add MPP image"
            onChange={handleImageMPPChange}
          />      
      }
    </LocalizationProvider>
  </div>
}

export const TimedImagesElementManager = (props) => {
  /*
  props:
  templateId: (must be provided for new )
  snippetInfo: (must be provided for edits )

  onChange: returns all the snippet info
  */


  //const {settings, setSettings} = useContext(SettingsContext);

  const [snippetName, setSnippetName] = useState('')
  const [snippetDesc, setSnippetDesc] = useState('')
  const [snippetSettings, setSnippetSettings] = useState(undefined)
  const [timeZones, setTimeZones] = useState(undefined);
  const [selectedTimeZoneId, setSelectedTimeZoneId] = useState("Europe/London");

  

  useEffect(() => {
    //console.log(props.snippetInfo)
    
    if (props.snippetInfo) { //we are in edit
      setSnippetName(props.snippetInfo.snippetName)
      setSnippetDesc(props.snippetInfo.snippetDesc)
      setSnippetSettings(props.snippetInfo.snippetSettings)
      if (props.snippetInfo.snippetSettings && props.snippetInfo.snippetSettings.selectedTimeZoneId) setSelectedTimeZoneId(props.snippetInfo.snippetSettings.selectedTimeZoneId)
    }
    else {
    }
    
  }, [props.snippetInfo])

  useEffect(() => {
    getTimezones()
    }, [])
  

  const getTimezones = async () => {
    try {  
      const url = `${process.env.REACT_APP_LION_API_URL}/Settings/timezones`;
      const response = await axios.get(url);
      const data = response.data;

      // const url = `${process.env.NEXT_PUBLIC_NEXT_API_URL}/Settings/timezones`;
      // const response = await fetch(url, { method: "GET", });    
      // const data = await response.json();

      const result = data.map(d => {return {id: d.zoneId, name: d.zoneName}});
      setTimeZones(result);

    } catch (error) {
      console.log(error);
    }
  }


  const prepareDataToPost = (updatePropName, updatePropValue) => {
    const result = {snippetId: 0, snippetName: '', snippetDesc: '', 
    labels: [{labelId: 0, labelName: ''}], href: '',
    snippetTypeId: 19,
    filters: [], orderBy: [],
    dataConnectionId: 0, templateId: 0, dataConnectionInfo: {},
    };

    result.snippetName = snippetName;
    result.snippetDesc = snippetDesc;
    result.snippetSettings = snippetSettings;

    if (updatePropName) {
      result[updatePropName] = updatePropValue;
    }
      //console.log(result)
      return result;
  }

  const handleSnippetNameChange = (newValue) => {
    setSnippetName(newValue)
    if (props.onChange) props.onChange(prepareDataToPost('snippetName', newValue))
  }
  const handleSnippetDescChange = (newValue) => {
    setSnippetDesc(newValue)
    if (props.onChange) props.onChange(prepareDataToPost('snippetDesc', newValue))
  }
const handleTimelineChange = (t) => {
  setSnippetSettings(t)
  if (props.onChange) props.onChange(prepareDataToPost('snippetSettings', t))
  }
const handleMppChange = (newValue) => {
  const newSettings = {...snippetSettings, imageMPP: newValue}
  if (props.onChange) props.onChange(prepareDataToPost('snippetSettings', newSettings))
}
const handleTimezoneChange = (timezone) => {
  const newSettings = {...snippetSettings, selectedTimeZoneId: timezone.id}
  //setSelectedTimeZoneId(timezone.id)
  if (props.onChange) props.onChange(prepareDataToPost('snippetSettings', newSettings))
}

    
return <>
      <div className="flex flex-row gap-x-4">
            <div className="w-[300px]">
            <InputText
                    displayName="Name"
                    value={snippetName}
                    onChange={(val) => {handleSnippetNameChange(val);}}
                    error={getErrorMessage(props.validationErrorsList, 'snippetName')}
            />
            </div>

            <div className="w-[300px]">
            <InputText
                        displayName="Description"
                        value={snippetDesc}
                        onChange={(val) => {handleSnippetDescChange(val);}}
                        error={getErrorMessage(props.validationErrorsList, 'snippetDesc')}
            />
            </div>
  
    </div>

    <div className="mt-2">
      <label htmlFor="snippetDescription" className="block text-sm font-poppins text-gray-900">
        Set the Time zone for all your dates
      </label>
      <div className="mt-2">
        <LionCombo items={timeZones}
        zIndex={100}
        onChange={handleTimezoneChange}
        selectedItemId={selectedTimeZoneId}
          />
      </div>
    </div>


    <TimelineEditor timeline={snippetSettings}
    onChange={handleTimelineChange}
    onMppChange={handleMppChange}
    validationErrorsList={props.validationErrorsList}
    />

    </>
}



export default function TimedImagesWorkflow(props) {
    const [currentStep, setCurrentStep] = useState(0);
    const navigate = useNavigate();
    const [templateId, setTemplateId] = useState(null);
    const [templateHasTimeLabels, setTemplateHasTimeLabels] = useState(false); // we check if the selected template contains time labels (by checking its templateJson)
    //const [snippetData, setSnippetData] = useState({snippetName: '', snippetDesc: '', href: '', wheelSettings: defaultWheelSettings});
    const [snippetData, setSnippetData] = useState(undefined); //it needs to start as undefined to resolve a bug in edit in chrome (popagation of onChange events that were overwriting the element metadata)


    const [successHtmlMsg, setSuccessHtmlMsg] = useState('');
    const [showErrorMsg, setShowErrorMsg] = useState(false);
    const [showLoader, setShowLoader] = useState(false);
    const [showSuccessMsg, setShowSuccessMsg] = useState(false);
    const [submitted, setSubmitted] = useState(false);

    const [activeErrorList, setActiveErrorList] = useState([]);
    const [progress, setProgress] = useState(0) //from 0 to 100


    useEffect(() => {
      if (props.snippetId) {
        getSnippetInfo(props.snippetId)
      }
      else {
        setSnippetData({snippetName: '', snippetDesc: '', })
      }
    }, [props.snippetId])

  const getSnippetInfo = async (snippetId) => {
      try {  
        const url = `${process.env.REACT_APP_LION_API_URL}/Snippets/${snippetId}`;
        const response = await axios.get(url);
        const data = response.data;
  
        const dataObj = {...data, wheelSettings: JSON.parse(data.snippetSettings).wheelSettings}
        //console.log(dataObj)
        setSnippetData(dataObj);
  
      } catch (error) {
        console.log(error);
      }
    }

    const templateContainsTimeLabels = (templateJson) => {
      let result = false;
      const blocks = templateJson.model.children[0].children;

      blocks.forEach(block => {
        if (block.className === "Text" && block.attrs.id.startsWith('timerLabel')) result = true;
      })
      console.log(result)
      return result;
    }

    const submitDataSnippet = async () => {
      try {
        //console.log(snippetData)
        //snippetDataValidationSchemaOSTracker.validateSync(snippetData, {abortEarly: false});
        setActiveErrorList([])
      }
      catch (e) {
        //console.log(JSON.parse(JSON.stringify(e)))
        const errorList = getErrorListFromYupError(e)
        setActiveErrorList(errorList)
        return false;
      }


      setShowLoader(true);
      setSuccessHtmlMsg('');
    
      try {
          let url = `${process.env.REACT_APP_LION_API_URL}/Snippets/create/19`;
          if (props.snippetId !== null && props.snippetId !== undefined) url = `${process.env.REACT_APP_LION_API_URL}/Snippets/update/19/${props.snippetId}`;
          const snippetSettings = snippetData.snippetSettings
          //console.log(snippetSettings)
          const dataToPost = {...snippetData, href: '', snippetSettings: JSON.stringify(snippetSettings)}

          const response = await axios.post(url, dataToPost);
    
          const snippetId = GetSnippetIdfromSnippetHtml(response.data)
    

          setSuccessHtmlMsg(response.data);
          setShowSuccessMsg(true);
      } catch (error) {
        setShowSuccessMsg(false);
        setShowErrorMsg(true);
        console.log(error);
      }
      setShowLoader(false);
      setSubmitted(true)

      return true;
    }
  const handleElementChange = (snippetInfo) => {
    console.log(snippetInfo)
    setSnippetData(snippetInfo)

    if (activeErrorList.length > 0) {
      try {
        snippetDataValidationSchemaTimedImages.validateSync(snippetInfo, {abortEarly: false});
        setActiveErrorList([])
      }
      catch (e) {
        const errorList = getErrorListFromYupError(e)
        setActiveErrorList(errorList)
        return;
      }  
    }
  }

  const handleNavChange = async(navInfo) => {

    if (navInfo.actionType === 'Submit') {
          let valid = true;
          try {
            //console.log(snippetData)
            snippetDataValidationSchemaTimedImages.validateSync(snippetData, {abortEarly: false});
            setActiveErrorList([])
          }
          catch (e) {
            //console.log(JSON.parse(JSON.stringify(e)))
            const errorList = getErrorListFromYupError(e)            
            
            //console.log(errorList)
            setActiveErrorList(errorList)
            valid = false
            if (errorList.length > 0)  return;
          }    
          if (valid) {
            setCurrentStep(navInfo.nextIndex);
            submitDataSnippet()  
          }
      }

    else setCurrentStep(navInfo.nextIndex);
    }
  
  const handleSaveExitClicked = () => {
      navigate("/ph/timedImages")
  }
  const handleNextClicked = (tId, tJson) => {
      setTemplateId(tId)
      setTemplateHasTimeLabels(templateContainsTimeLabels(tJson));
      setCurrentStep(2);
  }
  const handleClose = () => {
      navigate("/ph/timedImages")
  }


    return <div>
        <CcStepper2
            steps={[{ name: 'Configure timeline', href: '#' },
                    { name: 'Get Element', href: '#' },
                ]}
            currentStepIndex={currentStep}
        />
        <div className="border border-2 border-gray-200 rounded-md p-2">

            {currentStep === 0 && <TimedImagesElementManager
                                    onChange={handleElementChange}
                                    validationErrorsList={activeErrorList}
                                    snippetInfo={snippetData}
              />}

            {currentStep === 1 && <div className='flex flex-col items-center justify-center'>
                {showLoader && <> <div className='w-96'> <CcProgressBar variant="determinate" value={progress}/>
                </div></>}
                {showSuccessMsg && <SnippetCodeViewer numSnippets={1} html={successHtmlMsg} />}      
                {(showSuccessMsg || showErrorMsg) && <div> <CcActionButton variant="contained" onClick={handleClose} >Close</CcActionButton></div>}
            </div>}

            {currentStep !== 1 &&
                    <StepperNavButtons totalSteps={2}
                    currentStepNum={currentStep}
                    onChange={handleNavChange}
                    showClose={submitted}
                    onClose={handleClose}
                />
            }
        </div>

    </div>
}